module.exports = __webpack_public_path__ + "static/community_acupuncture-666f0dc864f0463a35ba44705ad01457.jpg";